export default "__VITE_ASSET__adf30047__"